$(document).ready(function(){
//$(this).parents(".customselect").children("[name="length"]").children("option:first").prop('selected', true);

//$('[name="length"]').children("option:first").prev().prop("selected", true);
   
  //$('[name="length"]').children("option:first").prop("selected", true);
  
  $(document).on("click", ".tab2", function(){
  $(".chairSize").css("display", "block");
     $(".SeatSize").css("display", "none");    
  })

 $(document).on("click", ".tab1", function(){
  $(".chairSize").css("display", "none");
     $(".SeatSize").css("display", "block");    
  })


// seat bolt 
$(document).on('click', ".submit", function(e){
     e.preventDefault();
 var seatLength = $("#lengthSelectorHandle").children("option:selected").val();  
  var seatWidth = $("#widthSelectorHandle").children("option:selected").val();
  var overHeight =  $("#heightSelectorHandle").children("option:selected").val(); 
   var overWidth =  $("#seatwidthSelectorHandle").children("option:selected").val(); 
  var seatDepth = $("#depthSelectorHandle").children('option:selected').val();
  var seatsheight = $("#seatshghtSelectorHandle").children("option:selected").val();  
 
// alert(seatlength  +"+" + seatwidth  +"+" + overheight +"+" + overwidth +"+" + seardepth) ;
  
window.location.href = "/collections/all/"+seatLength  +"+" + seatWidth  +"+" + overHeight +"+" + overWidth +"+" + seatDepth +"+" +seatsheight
});



  // tire size
  
  $(document).on('click', ".tiresubmit", function(e){
 e.preventDefault();
     var tireWidth = $("#tirewidthSelector").children("option:selected").val(); 
    var tireRatio = $("#ratioSelectorHandle").children("option:selected").val(); 
    var tireDiameter = $("#diameterSelectorHandle").children("option:selected").val(); 
    var tireRating = $("#ratingSelectorHandle").children("option:selected").val(); 
     var tiretype = $("#typeSelectorHandle").children("option:selected").val(); 
    
 // alert(tirewidth +"+" + tireratio +"+" + diameter +"+" + rating +"+" + type);
 window.location.href = "/collections/all/"+tireWidth +"+" + tireRatio +"+" + tireDiameter +"+" + tireRating +"+" + tiretype
    
  });
  

  
$(document).on('change', '.customselect', function(e){
 e.preventDefault();
  var demo = $("#lengthSelectorHandle").children("option:selected").val();  
          $('#widthSelectorHandle').prop('disabled', false);
  $(".customselect1").addClass("enable");
  
   if( demo == 'None')
   {
     $('#widthSelectorHandle').prop('disabled', true);
      $("#widthSelectorHandle").val("None");
      $('#heightSelectorHandle').prop('disabled', true);
     $('#heightSelectorHandle').val('None');
       $('#seatwidthSelectorHandle').prop('disabled', true);
      $('#seatwidthSelectorHandle').val('None');
      $('#depthSelectorHandle').prop('disabled', true);
       $('#depthSelectorHandle').val('None');
       $('#seatshghtSelectorHandle').prop('disabled', true);
       $('#seatshghtSelectorHandle').val('None');
       $('.submit').prop('disabled', true);
       $('.submit').val('None');
      $(".customselect1").removeClass("enable");
   }    
});

  
  $(document).on('change', '.customselect1', function(e){
   e.preventDefault();
     var demo1 = $("#widthSelectorHandle").children("option:selected").val();  
    $('#heightSelectorHandle').prop('disabled', false);
    $(".customselect2").addClass("enable"); $(".customselect1").removeClass('enable');
    
   if( demo1 == 'None')
   {
     $('#heightSelectorHandle').prop('disabled', true);
     $("#heightSelectorHandle").val("None");
     $('#seatwidthSelectorHandle').prop('disabled', true);
     $("#seatwidthSelectorHandle").val("None");
      $('#depthSelectorHandle').prop('disabled', true);
          $("#depthSelectorHandle").val("None");
      $('#seatshghtSelectorHandle').prop('disabled', true);
       $('#seatshghtSelectorHandle').val('None');
        $('.submit').prop('disabled', true);
        $(".submit").val("None");
      $(".customselect2").removeClass("enable");
   }
  });


  

  $(document).on('change', ".customselect2", function(e){
     e.preventDefault();
    var demo2 = $("#heightSelectorHandle").children("option:selected").val();  
    $('#seatwidthSelectorHandle').prop('disabled', false);
    $('.customselect3').addClass('enable'); $('.customselect2').removeClass('enable');

  if( demo2 == 'None')
   {
     $('#seatwidthSelectorHandle').prop('disabled', true);
          $("#seatwidthSelectorHandle").val("None");
     $('#depthSelectorHandle').prop('disabled', true);
     $("#depthSelectorHandle").val("None");
      $('#seatshghtSelectorHandle').prop('disabled', true);
       $('#seatshghtSelectorHandle').val('None');
     $('.submit').prop('disabled', true);
     $(".submit").val("None");
      $(".customselect3").removeClass("enable");
   }    
  });



  
  $(document).on('change', ".customselect3", function(e){
     e.preventDefault();
    var demo3 = $("#seatwidthSelectorHandle").children("option:selected").val();  
$('#depthSelectorHandle').prop('disabled', false);
     $('.customselect4').addClass('enable'); $('.customselect3').removeClass('enable');

if( demo3 == 'None')
   {
     $('#depthSelectorHandle').prop('disabled', true);
      $(".customselect4").removeClass("enable");
      $('#seatshghtSelectorHandle').prop('disabled', true);
       $('#seatshghtSelectorHandle').val('None');
   }    
  });


  
  	

  $(document).on('change', ".customselect4", function(e){
     e.preventDefault();
    var demo4 = $("#depthSelectorHandle").children("option:selected").val();  
$('#seatshghtSelectorHandle').prop('disabled', false);
      $('.customselect5').addClass('enable'); $('.customselect4').removeClass('enable');

if( demo4 == 'None')
   {
      $('#seatshghtSelectorHandle').prop('disabled', true);
     $('#seatshghtSelectorHandle').val('None');
      $(".customselect5").removeClass("enable");
   }
   
  });
  	


  
  $(document).on('change', ".customselect5", function(e){
     e.preventDefault();
    var demo5 = $("#seatshghtSelectorHandle").children("option:selected").val();  
$('.submit').prop('disabled', false);
     $('.customselect4').removeClass('enable');$('.submit').addClass('enable');

if( demo5 == 'None')
   {
     $('.submit').prop('disabled', true);
      $(".submit").removeClass("enable");
   }
   
  });
  





$(document).on('change', '.tirecustom1', function(e){
 e.preventDefault();
  var tr1 = $("#tirewidthSelector").children("option:selected").val(); 
          $('#ratioSelectorHandle').prop('disabled', false);
  $(".tirecustom2").addClass("enable");
  
 if( tr1 == 'None')
   {
     $('#ratioSelectorHandle').prop('disabled', true);
     $("#ratioSelectorHandle").val("None");
     $('#diameterSelectorHandle').prop('disabled', true);
     $('#diameterSelectorHandle').val('None');
     $('#ratingSelectorHandle').prop('disabled', true);
     $('#ratingSelectorHandle').val("None");
      $('#typeSelectorHandle').prop('disabled', true);
     $('#typeSelectorHandle').val("None");
     $(".tiresubmit").prop('disabled', true);
     $('.tiresubmit').val('None');
      $(".tirecustom2").removeClass("enable");
   }
});

 $(document).on('change', ".tirecustom2", function(e){
e.preventDefault();
   var tr2 = $("#ratioSelectorHandle").children("option:selected").val(); 
   $("#diameterSelectorHandle").prop('disabled', false);
   $('.tirecustom3').addClass("enable"); $(".tirecustom2").removeClass("enable");

    if( tr2 == 'None')
   {
     $('#diameterSelectorHandle').prop('disabled', true);
     $('#diameterSelectorHandle').val('None');
     $('#ratingSelectorHandle').prop('disabled', true);
     $('#ratingSelectorHandle').val('None');
     $('#typeSelectorHandle').prop('disabled', true);
     $('#typeSelectorHandle').val('None');
      $(".tiresubmit").prop('disabled', true);
     $('.tiresubmit').val('None');
      $(".tirecustom3").removeClass("enable");
   }
 }) 


  
 $(document).on('change', ".tirecustom3", function(e){
e.preventDefault();
   var tr3 = $("#diameterSelectorHandle").children("option:selected").val(); 
   $("#ratingSelectorHandle").prop('disabled', false);
   $('.tirecustom4').addClass("enable"); $(".tirecustom3").removeClass("enable");

  if( tr3 == 'None')
   {
     $('#ratingSelectorHandle').prop('disabled', true);
     $('#ratingSelectorHandle').val('None');
     $('#typeSelectorHandle').prop('disabled', true);
     $('#typeSelectorHandle').val('None');
     $(".tiresubmit").prop('disabled', true);
      $('.tiresubmit').val('None');
      $(".tirecustom4").removeClass("enable");
   }
   
 }) 


  
   $(document).on('change', ".tirecustom4", function(e){
e.preventDefault();
       var tr4 = $("#ratingSelectorHandle").children("option:selected").val(); 
   $("#typeSelectorHandle").prop('disabled', false);
   $('.tirecustom5').addClass("enable"); $(".tirecustom4").removeClass("enable");

      if( tr4 == 'None')
   {
     $('#typeSelectorHandle').prop('disabled', true);
      $(".tirecustom5").removeClass("enable");
   }
 })



   $(document).on('change', ".tirecustom5", function(e){
e.preventDefault();
     var tr5 = $("#typeSelectorHandle").children("option:selected").val(); 
   $(".tiresubmit").prop('disabled', false);
   $(".tirecustom5").removeClass("enable"); $('.tiresubmit').addClass('enable');

     if( tr5 == 'None'){
       $(".tiresubmit").prop('disabled', true);
       $(".tiresubmit").removeClass("enable");
     }
   
 })

  
// $(document).on('change', '.customselect.enable', function(e){
// e.preventDefault();
  
// var demo = $("#lengthSelectorHandle").children("option:selected").val();  
//   if( demo == 'None')
//   {
//     $('#widthSelectorHandle').prop('disabled', true);
   
//     $('#heightSelectorHandle').prop('disabled', true);
//      $('#seatwidthSelectorHandle').prop('disabled', true);
//     $('#depthSelectorHandle').prop('disabled', true);
//   }
 
// })

  $(document).on('click', '.ShopTires', function(){
$(this).addClass("active");$('.getservice').removeClass("active");
    
  });


 $(document).on('click', '.getservice', function(){
$(this).addClass("active"); $('.ShopTires').removeClass("active");
    
  });


$(document).on('click', '.tireshop', function(){
$(this).addClass("active");$('.tireservice').removeClass("active");   
});

 $(document).on('click', '.tireservice', function(){
 $(this).addClass('active'); $('.tireshop').removeClass("active");  
 }); 


  $(document).on('click', '.tab1', function(){
$(this).addClass("active");$('.tab2').removeClass("active");
    $('.Seattabinfo').css('display', 'flex');
  $('.Tiretabinfo').css('display', 'none');
    $(".SeatSectionwrap").addClass("AddSeatstructure").siblings().removeClass("AddTiretructure");
      $(".SearchInfo").removeClass("HideSeatContent");
   
  });


 $(document).on('click', '.tab2', function(){
$(this).addClass("active"); $('.tab1').removeClass("active");
   $('.Seattabinfo').css('display', 'none');
  $('.Tiretabinfo').css('display', 'flex');
    $(".TireSectionWrap").addClass("AddTiretructure").siblings().removeClass("AddSeatstructure");
   $(".SearchInfo").addClass("HideSeatContent");
   
  });


 //  $(window).on("load", function(){
  
 // var data = $('[name="length"]').children("option:first").prop("selected", true);
 //    alert(data);
 // }); 
  
});

  

